import { render, staticRenderFns } from "./VueChartjs.vue?vue&type=template&id=65841024&"
import script from "./VueChartjs.vue?vue&type=script&lang=js&"
export * from "./VueChartjs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports